import { getLocalStorageItem, setLocalStorageItem } from './local-storage';

export const getDefaultVolume = (): number => {
  const localStorageVolume = getLocalStorageItem('video.volume');
  return localStorageVolume ? parseFloat(localStorageVolume) : 0.5;
};

export const setDefaultVolume = (volume: string): void => {
  setLocalStorageItem('video.volume', volume);
};

export const getDefaultMutedState = (): boolean | null => {
  const muted = getLocalStorageItem('video.muted');
  return muted === 'false' ? false : muted === 'true' ? true : null;
};

export const setDefaultMutedState = (state: string): void => {
  setLocalStorageItem('video.muted', state);
};

export const getAllowAutoplayState = (): boolean => {
  const allowAutoplay = getLocalStorageItem('video.allowAutoplay');
  return allowAutoplay !== 'false';
};

export const setDefaultAllowAutoplayState = (state: string): void => {
  setLocalStorageItem('video.allowAutoplay', state);
};
